import { notFound, useParams } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { shopQuery } from '@/queries';
import { BrandFilter } from '@/components/brand-filter';
import { ProductCard } from '@/components/product-card';
import { EmptyState } from '@/components/ui';
import { accentTextStyle } from '@/lib/accent';

export default function BrandPage() {
  const { brand: slug } = useParams({ strict: false }) as { brand: string };
  const { brands, catalogue, activeBrand: brand } = useSuspenseQuery(shopQuery(slug)).data;
  if (!brand) throw notFound();

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      {/* Brand accent theming, FR-02. */}
      <header
        className="mb-8 border-l-[5px] pl-6"
        style={{ borderColor: brand.accent_hex }}
      >
        <h1
          className="accent-text text-[32px] font-extrabold tracking-[-0.03em] sm:text-[40px]"
          style={accentTextStyle(brand.accent_hex)}
        >
          {brand.name}
        </h1>
        {brand.tagline && <p className="mt-2 text-[17px] text-muted">{brand.tagline}</p>}
      </header>

      <BrandFilter brands={brands} active={slug} />

      {catalogue.length === 0 ? (
        <div className="mt-8">
          <EmptyState
            title={`No ${brand.name} products yet`}
            body="This label has nothing published right now. Try another brand, or start a custom order and we will print whatever you send us."
          />
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-[26px] lg:grid-cols-4">
          {catalogue.map((item) => (
            <ProductCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
